import { Link } from "react-router-dom";

const stages = [
  { name: "策略配置与审核", detail: "审核后的配置和策略引用定义研究逻辑；共享信号不携带账号交易授权。", href: "/forex/agents", link: "查看智能体" },
  { name: "账号授权与政策", detail: "平台账号和用户账号分别绑定身份、授权和账户风控。用户端只管理跟随关系。", href: "/forex/follow", link: "查看跟随关系" },
  { name: "Collector → MTF → 策略判断 / AI", detail: "Collector 提供研究行情。HOLD 和无信号属于已完成决策，不生成交易信号。", href: "/forex/agents", link: "查看研究运行" },
  { name: "共享策略信号 → 独立账号目标", detail: "信号发布后冻结各账号目标；主子账号独立准入、并发执行，无需等待主账号成交。", href: "/forex/execution-detail", link: "查看共享信号与逐账号结果" },
  { name: "账户风控 → 账号命令 → Outbox → EA", detail: "每个账号单独校验固定手数、报价、容量、身份和执行期限，通过现有 EA 通道执行。", href: "/forex/account-commands", link: "查看账号命令" },
  { name: "回报 → 核对 → 持仓与退出", detail: "命令提交、EA 回报和 Broker 成交分别记录；各账号持仓拥有自己的保护与退出责任。", href: "/forex/account-commands", link: "核对命令回报" },
];

export default function BusinessClosedLoopTab() {
  return <div className="space-y-4">
    <h2 className="text-lg font-semibold">业务链路说明</h2>
    <p className="text-sm text-text-muted">以下是流程与核对入口，不展示单个对象的实时闭环结果。HOLD 或无信号是正常完成的研究结果，不会产生交易命令。</p>
    <ol className="space-y-3">{stages.map((stage, index) => <li key={stage.name} className="relative border-b border-surface-border pb-4 pl-6 before:absolute before:left-2 before:top-2 before:bottom-0 before:border-l before:border-surface-border">
      <h3 className="font-medium">{index + 1}. {stage.name}</h3>
      <p className="my-2 text-sm text-text-secondary">{stage.detail}</p>
      <Link className="text-sm text-brand underline" to={stage.href}>核对入口：{stage.link}</Link>
    </li>)}</ol>
  </div>;
}
